import React, { useEffect, useState, useRef } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { TextField, Typography } from '@material-ui/core';
import { useEmailChangeStyle } from '../css/useEmailChangeStyle';
import alreadyRegisteredIcon from '../../sharedcomponents/images/alreadyRegisteredIcon.png';
import EirButton from '../../theme/EirButton';

function MyEirChangePasswordAndEmailToggle(props) {
    const containerRef = useRef(null);
    const classes = useEmailChangeStyle();
    const reactId = useRef(Math.random().toString(36).slice(2, 9));
    const modalBaseId = props.id || `custom-modal-${reactId.current}`;
    const titleId = props.heading || '';
    const descriptionId = props.newsContentText || '';
    // useEffect(() => {
    //     if (props.isopen) {
    //         document.getElementById(titleId)?.focus();
    //     }
    // }, [props.isopen, titleId]);
    useEffect(() => {
        if (props.isopen) {
            const timer = setTimeout(() => {
                if (containerRef.current) {
                    containerRef.current.focus();
                }
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [props.isopen]);
    return (
        <>
            <React.Fragment>
                <Modal
                    className={'emailSent-main'}
                    // wrapClassName="changeEmail-wrap"
                    wrapClassName={classes.ChangeEmailWrapper}
                    modalClassName={'emailSent-modal'}
                    backdropClassName={'emailSent-backdrop'}
                    contentClassName={'emailSent-content'}
                    isOpen={props.isopen}
                    toggle={props.toggle}
                    role='dialog'
                    aria-modal='true'
                    aria-labelledby={titleId}
                    aria-describedby={descriptionId}
                    ref={containerRef}
                    centered
                >
                    <ModalBody className='emailSent-body'>
                        <div className='emailSent-body-header'>
                            <Typography
                                className='emailSent-header-text'
                                id={titleId}
                                component='h2'
                                variant='h2'
                            >
                                {props.heading}
                            </Typography>
                        </div>
                        <div className='emailSent-body-content' id={descriptionId}>
                            <div className='emailSent-body-content-image'>
                                <img
                                    className='checkbox-image'
                                    src={alreadyRegisteredIcon}
                                    alt=''
                                />
                            </div>
                            <div className='emailSent-body-content-title'>
                                {props.newsContentText}
                            </div>
                            {props.subtext != '' ? (
                                <div className='emailSent-body-content-text'>
                                    {props.subtext}{' '}
                                    <span style={{ color: theme.palette.primary.heather }}>
                                        {props.email}
                                    </span>
                                    .
                                </div>
                            ) : (
                                ''
                            )}
                            <div className='emailSent-body-content-text'>
                                {props.subtextContinued}
                            </div>
                        </div>
                        <div className='emailSent-body-footer'>
                            <EirButton
                                style={{ padding: '0.5rem 1.875rem' }}
                                variants='primaryButtonMedium'
                                // className={
                                //     'emailSent-body-footer-cta primary-cta' +
                                //     (true ? ' cta-enabled' : ' cta-diabled')
                                // }
                                disabled={false}
                                onClick={() => {
                                    props.toggle();
                                }}
                                aria-label={props.buttonText}
                            >
                                {props.buttonText}
                            </EirButton>
                        </div>
                    </ModalBody>
                </Modal>
            </React.Fragment>
        </>
    );
}

export default MyEirChangePasswordAndEmailToggle;
